<script setup lang="ts">
import { ref } from "vue";

import AdminKnowledge from "./AdminKnowledge.vue";
import AdminSettings from "./AdminSettings.vue";
import AdminUsers from "./AdminUsers.vue";

/**
 * The admin panel (D18) — the two things that were being changed by hand before:
 * which model answers, and what mAImu knows.
 */
const tab = ref<"settings" | "knowledge" | "users">("knowledge");
</script>

<template>
  <section class="admin">
    <header class="admin-head">
      <h2>Haldus</h2>
      <nav class="tabs">
        <button type="button" :class="{ active: tab === 'knowledge' }" @click="tab = 'knowledge'">Teadmusbaas</button>
        <button type="button" :class="{ active: tab === 'users' }" @click="tab = 'users'">Kasutajad</button>
        <button type="button" :class="{ active: tab === 'settings' }" @click="tab = 'settings'">Seaded</button>
      </nav>
    </header>

    <AdminKnowledge v-if="tab === 'knowledge'" />
    <AdminUsers v-else-if="tab === 'users'" />
    <AdminSettings v-else />
  </section>
</template>

<style scoped>
.admin {
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.4rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.admin-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

h2 {
  margin: 0;
  font-size: 1.05rem;
}

.tabs {
  display: flex;
  gap: 0.3rem;
}

.tabs button {
  border: 1px solid var(--line);
  border-radius: 999px;
  background: transparent;
  padding: 0.25rem 0.75rem;
  font: inherit;
  font-size: 0.8rem;
  color: var(--muted);
  cursor: pointer;
}

.tabs button.active {
  color: var(--green);
  border-color: var(--green);
  font-weight: 600;
}
</style>
